import { ROLES } from '../../../contexts/RoleContext';

export const dashboardMetrics = {
  totalUsers: 1247,
  activeUsers: 892,
  totalProperties: 3456,
  savedProperties: 1234,
  totalRevenue: 234567,
  monthlyGrowth: 23
};

export const growthTrends = [
  { month: 'Jan', users: 400, properties: 240 },
  { month: 'Feb', users: 500, properties: 300 },
  { month: 'Mar', users: 600, properties: 450 },
  { month: 'Apr', users: 750, properties: 550 },
  { month: 'May', users: 890, properties: 600 },
  { month: 'Jun', users: 1000, properties: 700 }
];

export const propertyTypes = [
  { type: 'Single Family', percentage: 45 },
  { type: 'Multi Family', percentage: 25 },
  { type: 'Commercial', percentage: 20 },
  { type: 'Land', percentage: 10 }
];

export const priceTrends = [
  { month: 'Jan', avgPrice: 250000, medianPrice: 220000 },
  { month: 'Feb', avgPrice: 265000, medianPrice: 235000 },
  { month: 'Mar', avgPrice: 280000, medianPrice: 250000 },
  { month: 'Apr', avgPrice: 275000, medianPrice: 245000 },
  { month: 'May', avgPrice: 290000, medianPrice: 260000 },
  { month: 'Jun', avgPrice: 310000, medianPrice: 280000 }
];

export const locationDistribution = [
  { name: 'Downtown', value: 30 },
  { name: 'Suburbs', value: 45 },
  { name: 'Rural', value: 15 },
  { name: 'Industrial', value: 10 }
];

export const propertyStatus = [
  { status: 'Pre-Foreclosure', count: 150 },
  { status: 'Auction', count: 80 },
  { status: 'Bank Owned', count: 60 },
  { status: 'Short Sale', count: 40 }
];

export const mockUsers = Array.from({ length: 50 }, (_, index) => ({
  id: `user-${index + 1}`,
  email: `user${index + 1}@example.com`,
  name: `User ${index + 1}`,
  role: index === 0 ? ROLES.ADMIN : ROLES.CUSTOMER,
  status: index % 10 === 0 ? 'inactive' : 'active',
  lastLogin: '2024-02-20T10:30:00',
  joinDate: '2024-01-01T00:00:00'
}));

export const CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']; 